<template lang="pug">
.container-outras-habilidades
  .header
    .label Todas Habilidades
    .adicionar-habilidades
      ButtonPadrao(iconLeft variant="negative" @click="adicionarHabilidade")
        LucideIcon(slot="icon-left" name="Plus" :size="16")
        | Adicionar
  .corpo
    .habilidades(v-for="(item, i) in getTodasHabilidades" :key="i")
      .form
        el-form(class="form-custom-nexa" :model="item" :ref="`formRef${i}`" label-width="100px")
          .apagar
            LucideIcon(name="Trash2" :size="16" color="#fff" @click="removerHabilidade(i)")
            .selecao-habilidade
              SelectPadrao(
                :options="getHabilidades" 
                v-model="item.label" 
                label="Nome da Habilidade"
                @input="atualizarHabilidade(item.value, 'label', $event)"
              )
              //el-input(v-model="item.habilidade" placeholder="Sua habilidade")
        .selecao-nivel
          SelectPadrao(
            :options="getNiveis" 
            v-model="item.nivel" 
            label="Nível"
            @input="atualizarHabilidade(item.value, 'nivel', $event)"
          )
      .visualizacao
        BarraHabilidades(
          :key="item.nivel"
          skill="Visualização"
          :level="item.nivel"
          :showLevel="false"
        )
  .btn-salvar
    ButtonPadrao(iconLeft)
      LucideIcon(slot="icon-left" name="Save" :size="16")
      | Salvar Alterações
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import SelectPadrao from '@/components/ui/SelectPadrao.vue'
import BarraHabilidades from '@/components/ui/BarraHabilidades.vue'

export default {
  components: {
    ButtonPadrao,
    SelectPadrao,
    BarraHabilidades
  },

  computed: {
    ...mapGetters({
      getNiveis: 'habilidades/niveis',
      getHabilidades: 'habilidades/habilidades',
      getTodasHabilidades: 'habilidades/todasHabilidades'
    })
  },

  data() {
    return {
      habilidades: [{
        habilidade: '',
        nivel: ''
      }]
    }
  },

  methods: {
    ...mapMutations({
      setAdicionarHabilidade: 'habilidades/ADICIONAR_HABILIDADE',
      setRemoveHabilidade: 'habilidades/REMOVER_HABILIDADE'
    }),
    adicionarHabilidade() {
      this.setAdicionarHabilidade({
        label: '',
        value: '',
        nivel: 'Iniciando'
      })
    },
    removerHabilidade(index) {
      if (this.getTodasHabilidades.length > 1) {
        this.setRemoveHabilidade(this.getTodasHabilidades[index].value)
      } else {
        this.getTodasHabilidades[0].label = ''
        this.getTodasHabilidades[0].nivel = ''
      }
    },
    atualizarHabilidade(habilidadeValue, campo, novoValor) {
      const payload = { value: habilidadeValue }
      
      if (campo === 'nivel') {
        payload.novoNivel = novoValor
      } else if (campo === 'label') {
        payload.novaLabel = novoValor
        payload.value = habilidadeValue
      }
      
      this.$store.dispatch('habilidades/atualizarHabilidade', payload)
    }
  }
}
</script>

<style lang="scss">
.container-outras-habilidades{
  width: 100%;
  border: 1px solid $borderColor;
  box-sizing: border-box;
  border-radius: 8px;
  background: $corFundoPadraoDashboard;

  .header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    box-sizing: border-box;
    margin-bottom: 0;

    .label{
      font-size: 20px;
      font-weight: 700;
      color: $corVerdeClaro;
    }

    .adicionar-habilidades{
      .botao{
        height: 36px;
      }
    }
  }

  .corpo{
    padding: 0 24px 24px;

    .habilidades{
      border: 1px solid $borderColor;
      border-radius: 8px;
      background: $corPreto;
      padding: 16px;

      &:not(:last-child){
        margin-bottom: 24px;
      }

      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;

        .posicao{
          font-size: 16px;
          font-weight: 700;
          color: $corVerdeClaro;

          span{
            color: #fff;
            font-weight: 500;
            padding-left: 5px;
          }
        }
        .selecao-cor{
          width: 120px;
        }
      }
      .form{
        width: 100%;

        .apagar{
          position: relative;

          svg{
            position: absolute;
            right: 4px;
            cursor: pointer;

            &:hover{
              stroke: #f87171;
            }
          }
        }

        .selecao-nivel,
        .selecao-habilidade{
          .select-container{
            .el-select{
              width: 100%;

              .el-input{
                .el-input__inner{
                  background: #000;
                }
              }
            }
          }
        }
      }

      .visualizacao{
        margin-top: 24px;

        .progress-bar-container{
          .progress-bar-header{
            .title{
              color: $corValueInfoContato;
            }
          }
        }
      }
    }
  }

  .btn-salvar{
    padding: 16px 24px 24px;
    box-sizing: border-box;
    border-top: 1px solid $borderColor;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 500px) {
    .btn-salvar{
      justify-content: center;
    }
  }
}
</style>